<template>
  <b-form-group
    label="7. Indikasi Tercatat Gabungan (Gelondongan)"
    label-for="indikasiGabungan"
    label-size="lg"
    label-class="pb-0 pt-0"
  >
    <b-form-select
      id="indikasiGabungan"
      v-model="indikasiGabungan"
      :state="stateIndikasiGabungan"
      :options="dataIndikasiGabungan"
    />
    <b-form-invalid-feedback
      v-for="(error, index) of errorsIndikasiGabungan"
      :key="index"
    >
      {{ error.$message }}
    </b-form-invalid-feedback>
    <b-col
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
      v-if="indikasiGabungan == 1"
    >
      <b-form-group
        label="Keterangan"
        label-for="indikasiGabunganKeterangan"
        label-size="lg"
        label-class="pb-0 pt-0"
      >
        <b-form-input
          id="indikasiGabunganKeterangan"
          v-model="indikasiGabunganKeterangan"
          :state="stateIndikasiGabunganKeterangan"
        />
        <b-form-invalid-feedback
          v-for="(error, index) of errorsIndikasiGabunganKeterangan"
          :key="index"
        >
          {{ error.$message }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
  </b-form-group>
</template>

<script>
import { ref, watchEffect, watch } from "@vue/composition-api";

const propsString = { type: String, default: "" };
const propsBoolean = { type: Boolean, default: null };
const propsArray = { type: Array, default: () => [] };
export default {
  setup(props, context) {
    let indikasiGabungan = ref(null);
    let indikasiGabunganKeterangan = ref(null);

    watch(indikasiGabungan, () => {
      context.emit("emitIndikasiGabungan", indikasiGabungan.value);
    });

    watch(indikasiGabunganKeterangan, () => {
      context.emit(
        "emitIndikasiGabunganKeterangan",
        indikasiGabunganKeterangan.value
      );
    });

    watchEffect(() => {
      indikasiGabungan.value = props.indikasiGabunganVal;
      indikasiGabunganKeterangan.value = props.indikasiGabunganKeteranganVal;
    });

    return { indikasiGabungan, indikasiGabunganKeterangan };
  },
  props: {
    indikasiGabunganVal: propsString,
    stateIndikasiGabungan: propsBoolean,
    dataIndikasiGabungan: propsArray,
    errorsIndikasiGabungan: propsArray,
    indikasiGabunganKeteranganVal: propsString,
    stateIndikasiGabunganKeterangan: propsBoolean,
    errorsIndikasiGabunganKeterangan: propsArray,
  },
};
</script>
